import { appstr } from "./appstr";

export function SmartGetFieldValue(dbObj, fieldDef) {
  var s = dbObj.GetFieldValue(fieldDef);
  if (s == null || s.length == 0) s = appstr("Blank");
  return s;
}
